/**
 * Compensafe Branch Employee Selector v1.0
 *
 * Depends On:
 *  JQuery 1.7.2
 *  JQueryUI 1.8.19
 *
 *  Options:
        baseUrl: this widget calls web services and though it knows where the webservices are in the site, it needs to know what
            the root url of the site is, for example if the site is running under a virtual directory.
            Default is null, but this property is required.
            
        showAllBranchesOption: show an option in the branch dropdown for all branches. Label will be '--All--' and value will be 0.
        
        showAllEmployeesOption: show an option in the empoyee dropdown for all employees. Label will be '--All--' and value will be 0.
        
        branchList: branches to show in branch dropdown
            if branchList is a function, then it will be called by the widget when it needs to populate the branch dropdown.
                function must call this._populateBranchesFromList() and pass the data array.
            if branchList is an array, each item in the array must be an object with properties BrID which is the value and LOCAbbr 
                which is the text in the dropdown.
            Default calls internal function _getBranches() which calls a webservice. See this function for an example.
                
        employeeList: employees to show in branch dropdown
            if employeeList is a function, then it will be called by the widget when it needs to populate the employee dropdown.
                function must call this._populateEmployeesFromList() and pass the data array.
            if employeeList is an array, each item in the array must be an object with properties EmpID which is the value and LFName
                which is the text in the dropdown.
            Default calls internal function _getEmployees() which calls a webservice. See this function for an example.
        
        showBranchSelector: if True, then show Branch dropdown. if False, don't show branch dropdown and branchID must be set.
            Default is True.
        
        showEmployeeSelector: if True, then show Employee dropdown. if False, don't show employee dropdown.
            Default is True.
        
        branchID: Branch ID to default to.
        
        employeeID: Employee ID to default to.
        
        branchLabel: text to display next to Branch Dropdown.
            Default is 'Branch:'
        
        employeeLabel: text to display next to Employee Dropdown.
            Default is 'LO:'
        
        employeeTypes: which employees to display
            'LO' only display Loan Officers.
            'Scorecard' display employees with scorecard flag.
            'ALL' display all employees.
            Default is 'LO'.
        
        accessLevel: if you specify this value, the plugin will automaticly determine
            which select controls to show based on the value supplied.
        
        accessLevelType: there are different kinds of access levels that control
            a users access to site resources. When this plugin is used on a page
            the page's access level type should be specified.
            Default is 'Default'.

        showLowerALOnly: the employee list will only show employees with a lower
            AL than the user.
        
 *
 *  Public API:
        getSelection(): return the currently selected Branch and Employee IDs.
            Values are returned in an object with properties branchID and employeeID.            
        
        setSelection(branchID, employeeID): set the currently selected Branch and Employee IDs.
            If branchID is null, branchID will not be changed.
 *
 */
(function ($) {
    var oldApiUseReadonlySession = "?ReadOnlySession=true";
    $.widget("compensafe.branchEmployee",
    {       
        options:
        {
            baseUrl: null,
            showAllRegionsOption: true,
            showAllBranchesOption: true,
            showAllEmployeesOption: true,
            regionList: null,
            branchList: null,
            employeeList: null,
            showRegionSelector: true,
            showBranchSelector: true,
            showEmployeeSelector: true,
            regionID: null,
            branchID: null,
            branchNumber: null,
            brInclSubs: null,
            employeeID: null,
            loadOnCreate: true,
            regionLabel: "Reg:",
            branchLabel: "Br:",
            employeeLabel: "Emp:",
            branchActive: 1,
            employeeTypes: 'ALL',
            accessLevel: null,
            accessLevelType: 'Default',
            preserveSelectionWhenExpandingQuery: true,
            RegionBranchEmployeeLSKey: "RBE",
            showLowerALOnly: false,
            orientation: "Horizontal",
            autoWidth: false,
            branchDisplayText: ["LOC", "AbbrName"],  // options = "LOC", "AbbrName", "BranchName", "FullName"
            branchDisplayAllOption: false
        },
        _create: function() {
            var self = this;
            // validate inputs
            var o = self.options;

            if (o.baseUrl === null) {
                throw { Message: 'baseUrl must be set' };
            }
            //only set options from local storage if all 3 are null coming in
            if (!o.regionID && !o.branchID && !o.employeeID) {
                var rbe = self._getStoredRBEValues();
                o.regionID = rbe.RegID;
                o.branchID = rbe.BrID;
                o.employeeID = rbe.EmpID;
            }

            // if you want to automatically show/hide, then set accessLevel
            // otherwise, set showRegionSelector, showBranchSelector, showEmployeeSelector
            // to false if you want to hide any of these.
            // if you set both, then the automatic behavior will take precedence.
            if (o.accessLevel !== null) {
                if (o.accessLevel <= 1) {
                    o.showBranchSelector = false;
                    o.showEmployeeSelector = false;
                }

                if (o.accessLevel < 4) {
                    o.showRegionSelector = false;
                    o.showAllRegionsOption = false;
                }
                else {
                    o.showRegionSelector = true;
                }
            }

            if (o.regionID !== null) {
                o.regionID = parseInt(o.regionID);
            }

            var branchNumberPromise = null;

            if (o.branchNumber !== null) {
                var GetBranchInfoByLOCParams =
                {
                    AccessLevelType: o.accessLevelType,
                    RegID: o.regionID,
                    Loc: o.branchNumber
                };
                branchNumberPromise = $.postJson("~/LoanData.asmx/GetBranchInfoByLOC", GetBranchInfoByLOCParams, function (d) {
                    if (d !== null && typeof d !== "undefined" && d.d !== null && typeof d.d !== "undefined") {
                        o.branchID = parseInt(d.d.BrID);
                    }
                });
            }
            else if (o.branchID !== null) {
                o.branchID = parseInt(o.branchID);
            }

            if (o.employeeID !== null) {
                o.employeeID = parseInt(o.employeeID);
            }

            if (o.regionList === null) {
                o.regionList = $.proxy(self._getRegions, this);
            }

            if (o.branchList === null) {
                o.branchList = $.proxy(self._getBranches, this);
            }

            if (o.employeeList === null) {
                if (o.showLowerALOnly) {
                    o.employeeList = $.proxy(self._getEmployeesLowerALOnly, this);
                }
                else {
                    o.employeeList = $.proxy(self._getEmployees, this);
                }
            }

            // create internal HTML
            self._createPrefix();

            self.element.addClass('ui-widget');
            self.element.addClass('compensafe-branchEmployee');

            var containerClass = '';
            if (o.orientation.toLowerCase() === 'vertical') {
                containerClass = 'compensafe-branchEmployee-controlGroup-vert';
            }
            else {
                containerClass = 'compensafe-branchEmployee-controlGroup';
            }
            if (o.autoWidth) {
                containerClass += ' compensafe-branchEmployee-autoWidth';
            }

            var regionHtml =
            '<div class="' + containerClass + '">' +
            '<label class="compensafe-branchEmployee-region" for="' + self._id('region') + '">' + o.regionLabel + '</label>' +
            '<select class="compensafe-branchEmployee-region" id="' + self._id('region') + '" name="' + self._id('region') + '"><option value="loading">Loading...</option></select>' +
            '&nbsp;<span id="resetreg"><span class="glyphicon glyphicon-refresh" aria-hidden="true"></span></span></div>';
            var regionHiddenHtml = '<input id="' + self._id('region') + '" name="' + self._id('region') + '" type="hidden"/>';
            var branchHtml =
            '<div class="' + containerClass + '">' +
            '<label class="compensafe-branchEmployee-branch" for="' + self._id('branch') + '">' + o.branchLabel + '</label>' +
            '<select class="compensafe-branchEmployee-branch" id="' + self._id('branch') + '" name="' + self._id('branch') + '"><option value="loading">Loading...</option></select>' +
            '&nbsp;<span id="resetbr"><span class="glyphicon glyphicon-refresh" aria-hidden="true"></span></span></div>';
            var branchHiddenHtml = '<input id="' + self._id('branch') + '" name="' + self._id('branch') + '" type="hidden"/>';
            var employeeHtml =
            '<div class="' + containerClass + '">' +
            '<label class="compensafe-branchEmployee-employee" for="' + self._id('employee') + '">' + o.employeeLabel + '</label>' +
            '<select class="compensafe-branchEmployee-employee" id="' + self._id('employee') + '" name="' + self._id('employee') + '"><option value="loading">Loading...</option></select>' +
            '&nbsp;<span id="resetemp"><span class="glyphicon glyphicon-refresh" aria-hidden="true"></span></span></div>';
            var employeeHiddenHtml = '<input id="' + self._id('employee') + '" name="' + self._id('employee') + '" type="hidden"/>';

            if (o.showRegionSelector === true) {
                self.element.append(regionHtml);

                $('#' + self._id('region')).select2({
                    selectOnClose: true,
                    closeOnSelect: true,
                    multiple: false,
                    width: 'auto',
                    height: 'resolve',
                    dropdownAutoWidth: true,
                });
            }
            else {
                self.element.append(regionHiddenHtml);
            }

            if (o.showBranchSelector === true) {
                self.element.append(branchHtml);

                $('#' + self._id('branch')).select2({
                    selectOnClose: true,
                    closeOnSelect: true,
                    multiple: false,
                    width: 'auto',
                    height: 'resolve',
                    dropdownAutoWidth: true,
                });
            }
            else {
                self.element.append(branchHiddenHtml);
            }

            if (o.showEmployeeSelector === true) {
                self.element.append(employeeHtml);

                $('#' + self._id('employee')).select2({
                    selectOnClose: true,
                    closeOnSelect: true,
                    multiple: false,
                    width: 'auto',
                    height: 'resolve',
                    dropdownAutoWidth: true,
                });
            }
            else {
                self.element.append(employeeHiddenHtml);
            }

            // bind internal event handlers
            $('#' + self._id('region')).on('change', $.proxy(self._populateBranches, self));
            $('#' + self._id('branch')).on('change', $.proxy(self._populateEmployees, self));
            $('#' + self._id('employee')).on('change', $.proxy(self._employeeChange, self));

            o.initialLoad = true;

            $('#resetreg').on('click', function () {
                var rbe = self.getSelection();
                if (rbe.regionID > 0) {
                    self._resetRegion();
                }
            });

            $('#resetbr').on('click', function () {
                var rbe = self.getSelection();
                if (rbe.branchID > 0) {
                    self._resetBranch();
                }
            });

            $('#resetemp').on('click', function () {
                var rbe = self.getSelection();
                if (rbe.employeeID > 0) {
                    self._resetEmployee();
                }
            });

            if (o.showAllRegionsOption === false) {
                $('#resetreg').hide();
            }

            if (o.showAllBranchesOption === false) {
                $('#resetbr').hide();
            }

            if (o.showAllEmployeesOption === false) {
                $('#resetemp').hide();
            }

            var displayTextPromise =
                $.ajax({
                    type: 'POST',
                    url: self._getUrl('LoanData.asmx/GetBranchDisplayText' + oldApiUseReadonlySession),
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    success: function (d) {
                        self.options.branchDisplayText = d.d;
                    }
                });

            var employeeDropdownParam = $.ajax({
                type: 'POST',
                url: self._getUrl('LoanData.asmx/GetCompanyParam' + oldApiUseReadonlySession),
                data: JSON.stringify({
                    paramName: "EmployeeDropdown"
                }),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                success: function (resp) {
                    self.options.employeeDropDownParamValue = resp.d ? resp.d.ParamValue : 0;
                }
            });

            $.when(branchNumberPromise, displayTextPromise, employeeDropdownParam).then(function () {
                if (self.options.loadOnCreate === true) {
                    self._populateRegions();
                }
            });
            
        },
        _createPrefix: function() {
            var self = this;
            // if element has an id, then use that for prefix
            var id = self.element.attr('id');
            if (id == null) {
                id = self.widgetBaseClass + parseInt(Math.random() * 10000);
            }

            self.options.prefix = id + '-';
        },
        _id: function(id) {
            var self = this;
            return self.options.prefix + id;
        },
        _getUrl: function(url) {
            var self = this;
            return '' + self.options.baseUrl + url;
        },
        _populateRegions: function() {
            var self = this;

            if (self.options.showRegionSelector === true) {
                $('#' + self._id('region')).empty().append('<option value="loading">Loading...</option>');

                if (typeof (self.options.regionList) === "function") {
                    //todo: what is this doing? should it be self._populateRegionesFromList(self.options.regionList()); or have I just forgotten something?
                    self.options.regionList();
                }
                else if (typeof (self.options.regionList) === "object" || self.options.regionList === null) {
                    if (Array.isArray(self.options.regionList) || self.options.regionList === null) {
                        self._populateRegionsFromList(self.options.regionList);
                    }
                }
            }
            else if (self.options.regionID != null) {
                $('#' + self._id('region')).val(self.options.regionID);
                self.options.regionID = null;
                self._populateBranches();
            }
        },
        _populateRegionsFromList: function(regions) {
            var self = this;
            var jqRegion = $('#' + self._id('region'));
            jqRegion.empty();

            if (self.options.showAllRegionsOption === true) {
                $('<option></option>')
                    .attr('value', 0)
                    .prop('selected', true)
                    .text('-All-')
                    .appendTo(jqRegion);
            }

            if (regions != null) {
                $.each(regions, function(i, v) {
                    var o = $('<option></option>').attr('value', v.RegID).text(v.RegionName);
                    var r = parseInt(v.RegID);
                    if (r === self.options.regionID && !isNaN(r)) {
                        o.prop('selected', true);
                    }
                    o.appendTo(jqRegion);
                });

                // fix for IE9 bug. sometimes IE9 will only show the first character of the
                // item in the dropdown. I don't know what triggers this but this will fix it
                // http://stackoverflow.com/questions/5908494/select-only-shows-first-char-of-selected-option
                //jqRegion.width(jqRegion.width());
            }
            self._regionChange();
        },
        _getRegions: function() {
            var self = this;
            var bp =
            {
                AccessLevelType: self.options.accessLevelType
            };
            $.ajax({
                type: 'POST',
                url: self._getUrl('LoanData.asmx/GetRegionInfo' + oldApiUseReadonlySession),
                data: JSON.stringify(bp),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                success: function(d) {
                    self._populateRegionsFromList(d.d);
                }
            });
        },
        _populateBranches: function() {
            var self = this;

            if (self.options.preserveSelectionWhenExpandingQuery === true) {
                var tmpbr = parseInt($("#" + self._id('branch')).val());
                if (!isNaN(tmpbr))
                {
                    self.options.branchID = tmpbr;
                }
            }

            if (self.options.showBranchSelector === true) {
                $('#' + self._id('branch')).empty().append('<option value="loading">Loading...</option>');

                if (typeof (self.options.branchList) === "function") {
                    var regionParams =
                    {
                        regionID: $('#' + self._id('region')).val()
                    };
                    self.options.branchList(regionParams);
                }
                else if (typeof (self.options.branchList) === "object" || self.options.branchList == null) {
                    if (Array.isArray(self.options.branchList) || self.options.branchList == null) {
                        self._populateBranchesFromList(self.options.branchList);
                    }
                }
            }
            else if (self.options.branchID !== null) {
                $('#' + self._id('branch')).val(self.options.branchID);
                self.options.branchID = null;
                self._populateEmployees();
            }
            else {
                $('#' + self._id('branch')).val(0);
                self._branchChange();
            }
        },
        _populateBranchesFromList: function(branches) {
            var self = this;
            var jqBranch = $('#' + self._id('branch'));
            jqBranch.empty();

            if (self.options.showAllBranchesOption === true) {
                $('<option></option>')
                    .attr('value', 0)
                    .prop('selected', true)
                    .text(self.options.branchDisplayAllOption ? '-All-' : '--')
                    .appendTo(jqBranch);
            }
            //fix above.  CS-16469: If branchDisplayAllOption is set, show all.  Otherwise, show '--'

            if (null == branches) {
                //do nothing; it's null or undefined
            }
            else {
                $.each(branches, function (i, v) {
                    var o = $('<option></option>').attr('value', v.BrID).text(v.DisplayText);

                    var b = parseInt(v.BrID);
                    if (b === self.options.branchID && !isNaN(b)) {
                        o.prop('selected', true);
                    }
                    o.appendTo(jqBranch);
                });

                // fix for IE9 bug. sometimes IE9 will only show the first character of the
                // item in the dropdown. I don't know what triggers this but this will fix it
                // http://stackoverflow.com/questions/5908494/select-only-shows-first-char-of-selected-option
                //jqBranch.width(jqBranch.width());
            }
            self._branchChange();
        },
        _getBranches: function(regionParams) {
            var self = this;
            var bp =
            {
                RegionID: regionParams.regionID,
                BrInclSubs: self.options.brInclSubs,
                Active: self.options.branchActive,
                AccessLevelType: self.options.accessLevelType
            };
            $.postJson('~/LoanData.asmx/GetBranchInfo', bp, function (d) {
                self._populateBranchesFromList(d.d);
            });
        },
        _populateEmployees: function() {
            var self = this;

            if (self.options.preserveSelectionWhenExpandingQuery === true) {
                var tmpemp = parseInt($('#' + self._id('employee')).val());
                if (!isNaN(tmpemp)) {
                    self.options.employeeID = tmpemp;
                }
            }

            if (self.options.showEmployeeSelector === true) {
                $('#' + self._id('employee')).empty().append('<option value="loading">Loading...</option>');

                if (typeof (self.options.employeeList) === "function") {
                    var branchParams =
                    {
                        regionID: $('#' + self._id('region')).val(),
                        branchID: $('#' + self._id('branch')).val()
                    };
                    self.options.employeeList(branchParams);
                }
                else if (typeof (self.options.employeeList) === "object" || self.options.employeeList === null) {
                    if (Array.isArray(self.options.employeeList) || self.options.employeeList == null) {
                        //todo: filter list by branch
                        self._populateEmployeesFromList(self.options.employeeList);
                    }
                }
            }
            else if (self.options.employeeID != null) {
                $('#' + self._id('employee')).val(self.options.employeeID);
                self.options.employeeID = null;
                self._employeeChange();
            }
            else {
                $('#' + self._id('employee')).val(0);
                self._employeeChange();
            }
        },
        _populateEmployeesFromList: function(employees) {
            
            var self = this;
            var jqEmployee = $('#' + self._id('employee'));
            jqEmployee.empty();

            if (self.options.showAllEmployeesOption === true) {
                $('<option></option>')
                    .attr('value', 0)
                    .prop('selected', true)
                    .text('-All-')
                    .appendTo(jqEmployee);
            }

            if (employees != null) {
                var empOptions = '';
                for (var i = 0; i < employees.length; i++) {              
                    empOptions += '<option value="' + employees[i].EmpID;               
                    empOptions += employees[i].EmpID === self.options.employeeID 
                        ? '" selected>' 
                        : '">';

                    switch(self.options.employeeDropDownParamValue) {
                        case "0":
                            empOptions += replaceSpecialChars(employees[i].LFName);
                            break;
                        case "1":
                            empOptions += replaceSpecialChars(employees[i].LFName) + ' ' + replaceSpecialChars(employees[i].FileNo);
                            break;
                        case "2":
                            empOptions += replaceSpecialChars(employees[i].LFName) + ' (' + employees[i].LOC + ')';
                            break;
                        case "3":
                            empOptions += replaceSpecialChars(employees[i].LFName) + ' ' + replaceSpecialChars(employees[i].FileNo) + ' (' + employees[i].LOC + ')';
                            break;
                        case "4":
                            empOptions += replaceSpecialChars(employees[i].FileNo) + ' ' + replaceSpecialChars(employees[i].LFName);
                            break;
                        case "5":
                            empOptions += replaceSpecialChars(employees[i].FileNo) + ' ' + replaceSpecialChars(employees[i].LFName) + ' (' + employees[i].LOC + ')';
                            break;
                        case "6":
                            empOptions += replaceSpecialChars(employees[i].FirstName) + ' ' + replaceSpecialChars(employees[i].LastName) + ' ';
                            break;
                        case "7":
                            empOptions += replaceSpecialChars(employees[i].FileNo) + ' ' + replaceSpecialChars(employees[i].FirstName) + ' ' + replaceSpecialChars(employees[i].LastName) + ' ';
                            break;
                        case "8":
                            empOptions += replaceSpecialChars(employees[i].FirstName) + ' ' + replaceSpecialChars(employees[i].LastName) + ' ' + replaceSpecialChars(employees[i].FileNo);
                            break;
                    }

                    switch (self.options.employeeDropDownParamValue) {
                        case "6":
                        case "7":
                        case "8":
                            if (employees[i].Active == false) {
                                empOptions += " (I)";
                            }
                    }

                    empOptions += '</option>';
                }
                jqEmployee.append(empOptions)
                
                // old version
                //$.each(employees, function(i, v) {
                //    var o = $('<option></option>').attr('value', v.EmpID).text(v.LFName);
                //    var emp = parseInt(v.EmpID);
                //    if (emp === self.options.employeeID && !isNaN(emp)) {
                //        o.attr('selected', 'selected');
                //    }
                //    o.appendTo(jqEmployee);
                //});

                // fix for IE9 bug. sometimes IE9 will only show the first character of the
                // item in the dropdown. I don't know what triggers this but this will fix it
                // http://stackoverflow.com/questions/5908494/select-only-shows-first-char-of-selected-option
                //jqEmployee.width(jqEmployee.width());
            }
            self._employeeChange();
        },
        _getEmployees: function(BranchParams) {
            var self = this;

            var bp =
            {
                RegionID: BranchParams.regionID,
                BranchID: BranchParams.branchID,
                AccessLevelType: self.options.accessLevelType
            };

            var wsUrl = self._getUrl('LoanData.asmx/GetDefaultEmployeeDropdown');

            if (self.options.employeeTypes === "LO") {
                wsUrl = self._getUrl('LoanData.asmx/GetLoanOfficerInfo');
            }
            else if (self.options.employeeTypes === "Scorecard") {
                wsUrl = self._getUrl('LoanData.asmx/GetEmployees');
                bp.Active = 2;
                bp.EmpOptType = "S";
                bp.BrInclSubs = true;
                bp.AllowOwnTransactions = true;
            }
            else if (self.options.employeeTypes === "WatchList") {
                wsUrl = self._getUrl('LoanData.asmx/GetEmployees');
                bp.Active = 2;
                bp.EmpOptType = "W";
                bp.BrInclSubs = true;
                bp.AllowOwnTransactions = true;
            }

            $.ajax({
                type: 'POST',
                url: wsUrl,
                data: JSON.stringify(bp),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                success: function(d) {
                    self._populateEmployeesFromList(d.d);
                }
            });
        },
        _getEmployeesLowerALOnly: function (BranchParams) {
            var self = this;
            var wsUrl = self._getUrl('LoanData.asmx/GetEmployeesLowerAL');

            var bp =
            {
                RegionID: BranchParams.regionID,
                BranchID: BranchParams.branchID,
                AccessLevelType: self.options.accessLevelType
            };

            $.ajax({
                type: 'POST',
                url: wsUrl,
                data: JSON.stringify(bp),
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                success: function (d) {
                    self._populateEmployeesFromList(d.d);
                }
            });
        },
        _regionChange: function() {
            var self = this;
            var jqRegion = $('#' + self._id('region'));

            if (self.options.showRegionSelector === true) {
                jqRegion.trigger('change');
            }
            else {
                self._populateBranches();
            }
        },
        _branchChange: function() {
            var self = this;
            var jqBranch = $('#' + self._id('branch'));

            if (self.options.showBranchSelector === true) {
                jqBranch.trigger('change');
            }
            else {
                self._populateEmployees();
            }
        },
        _employeeChange: function() {
            var self = this;
            var cur = self.getSelection();
            var rbe = {
                RegID: cur.regionID,
                BrID: cur.branchID,
                EmpID: cur.employeeID
            };
            self._updateStoredRBEValues(rbe);

            if (self.options.initialLoad === true) {
                self.options.initialLoad = false;
                self.options.regionID = null;
                self.options.branchID = null;
                self.options.employeeID = null;
                self._trigger("initialloadcomplete", null, self.getSelection());
            }
            else {

                //
                clearTimeout(self._timeout);
                self._timeout = window.setTimeout(function () {
                    self._trigger("change", null, self.getSelection());
                }, 800);
            }
        },
        _getStoredRBEValues: function () {
            var self = this;
            var o = self.options;

            var rc = {RegID: 0, BrID: 0, EmpID: 0};
            if (window.localStorage) {
                var rcStr = localStorage.getItem(o.RegionBranchEmployeeLSKey);
                if (rcStr) {
                    rc = JSON.parse(rcStr);
                }
            }
            return rc;
        },
        _updateStoredRBEValues: function (RbeVal) {
            var self = this;
            var o = self.options;

            if (window.localStorage) {
                var RbeJson = JSON.stringify(RbeVal);
                try {
                    localStorage.setItem(o.RegionBranchEmployeeLSKey, RbeJson);
                } catch(e) {
                  if (isQuotaExceeded(e)) {
                      console.log("local storage error captured, your web browser does not support storing settings locally");
                      var i;
                      for (i = 0; i < localStorage.length; i++) {
                        console.log(localStorage.key(i) + "=[" + localStorage.getItem(localStorage.key(i)) + "]");
                      }
                  }
                }
            }
        },
        _setOption: function (key, value) {
        },
        destroy: function() {
            // In jQuery UI 1.8, you must invoke the destroy method from the base widget
            $.Widget.prototype.destroy.call(this);
            // In jQuery UI 1.9 and above, you would define _destroy instead of destroy and not call the base method

            this.element.empty();
        },
        _destroy: function() {
            this.element.empty();
        },
        getSelection: function() {
            var self = this;
            var rc =
            {
                regionID: $('#' + self._id('region')).val(),
                branchID: $('#' + self._id('branch')).val(),
                employeeID: $('#' + self._id('employee')).val()
            };

            if (rc.regionID === 'loading' || // isNaN(parseInt(rc.regionID)) &&
                rc.branchID === 'loading' || // isNaN(parseInt(rc.regionID)) &&
                rc.regionID === 'loading' // || isNaN(parseInt(rc.regionID))
            ) {
                rc.notFinishedLoading = true;
            }

            rc.regionID = parseInt(rc.regionID);
            rc.branchID = parseInt(rc.branchID);
            rc.employeeID = parseInt(rc.employeeID);

            if (isNaN(rc.regionID) === true) {
                rc.regionID = 0;
            }

            if (isNaN(rc.branchID) === true) {
                rc.branchID = 0;
            }

            if (isNaN(rc.employeeID) === true) {
                rc.employeeID = 0;
            }

            return rc;
        },
        setSelection: function(regionID, branchID, employeeID) {
            var self = this;
            self.options.regionID = parseInt(regionID);
            self.options.branchID = parseInt(branchID); //todo: if we change branch id to LOC, then don't parseInt()
            self.options.employeeID = parseInt(employeeID);
            self._populateRegions();
        },
        _resetRegion: function () {
            var self = this;
            var o = self.options;
            self.options.regionID = 0;
            self._populateRegionsFromList();
            self._populateRegions();
        },
        _resetBranch: function () {
            var self = this;
            var o = self.options;
            self.options.branchID = 0;
            self._populateBranchesFromList();
            self._populateBranches();
        },
        _resetEmployee: function () {
            var self = this;
            var o = self.options;
            self.options.employeeID = 0;
            self._populateEmployeesFromList();
            self._populateEmployees();
        }
    });
})(jQuery);

function compare(field) {
    return function (a, b) {
        if (a[field] < b[field])
            return -1;
        if (a[field] > b[field])
            return 1;
        return 0;
    };
}